import { create } from "zustand";
import { persist } from "zustand/middleware";
import { AppData } from "./types";

const tag = "@/store/useAppData";

export const useAppData = create<AppData>()(
  persist(
    (set) => ({
      user: null,
      setUser: (user) => set({ user }),
      selectedStock: null,
      setSelectedStock: (selectedStock) => set({ selectedStock }),
      selectedModule: null,
      setSelectedModule: (selectedModule) => set({ selectedModule }),
      displaySettings: false,
      setDisplaySettings: (displaySettings) => set({ displaySettings }),
      selectedDeicing: null,
      setSelectedDeicing: (selectedDeicing) => set({ selectedDeicing }),
      secondOperator: null,
      setSecondOperator: (secondOperator) => set({ secondOperator }),
    }),
    {
      name: "app-data",
      partialize: (state) => ({
        user: state.user
      })
    }
  )
);

export default useAppData;